import { cn } from '@lib/cn'
import React, { AnchorHTMLAttributes, FC } from 'react'

type CtaButtonRowLinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  children?: React.ReactNode
  icon: React.ReactNode
  variant?: 'white' | 'transparent'
}

export const CtaButtonRowLink: FC<CtaButtonRowLinkProps> = ({
  children,
  variant = 'white',
  icon,
  ...rest
}) => {
  return (
    <a
      className={cn(
        'group mx-[10px] flex flex-wrap items-center text-[14px] transition-colors duration-150 lg:mx-0 lg:my-2',
        variant === 'white' && 'text-white',
      )}
      {...rest}
    >
      <div
        className={cn(
          'flex h-[50px] w-[50px] items-center justify-center rounded-3xl bg-transparent text-rolexPrimary transition-colors duration-150',
          'lg:mr-4 lg:h-9 lg:w-9',
          variant === 'transparent'
            ? 'border border-solid border-rolexPrimary bg-transparent text-rolexPrimary group-hover:bg-white group-hover:text-rolexPrimary lg:border-white lg:text-white'
            : 'bg-white group-hover:bg-rolexPrimary group-hover:text-white lg:text-rolexPrimary',
        )}
      >
        {icon}
      </div>
      {children && children}
    </a>
  )
}
